import { render, staticRenderFns } from "./EventConfiguration.vue?vue&type=template&id=af3b679e&"
import script from "./EventConfiguration.vue?vue&type=script&lang=js&"
export * from "./EventConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../var/www/html/film-screening-production/vuejs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../var/www/html/film-screening-production/vuejs/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VFlex,VIcon,VLayout,VTooltip})
